import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import { getFormattedAddress } from '../../../../Helpers/AddressHelper';
import {
  areBrokerFunctionsAvailable,
  areDecoupledFunctionsAvailableFunction,
  canParentTeamBeSet,
  canTeamMobileNumberBeSet,
  canTeamNameBeSet,
  canTeamResponsibleTypeBeSet,
} from '../../Functions';

export const getTeamHeaderItems = ({ team, legalUnitName, isTestEnvironment }) => {
  const result = [
    {
      key: 'codePrefix',
      title: formatMessage(Messages.common_codePrefix),
      value: team.codePrefix,
      width: 120,
    },
  ];

  if (isTestEnvironment && canTeamResponsibleTypeBeSet(legalUnitName)) {
    result.push({
      key: 'teamResponsibleType',
      title: formatMessage(Messages.teamInfo_teamResponsibleType),
      value: team.responsibleType,
      width: 100,
    });
  }

  result.push({
    key: 'userId',
    title: formatMessage(Messages.common_userId),
    value: team.userId,
    width: 120,
  });

  if (canTeamNameBeSet(legalUnitName)) {
    result.push({
      key: 'teamName',
      title: formatMessage(Messages.common_teamName),
      value: team.name,
      width: 150,
    });
  } else if (areDecoupledFunctionsAvailableFunction(team)) {
    result.push({
      key: 'commonAgentName',
      title: formatMessage(Messages.common_name),
      value: team.commonAgentName,
      width: 150,
    });
  }

  if (areBrokerFunctionsAvailable(team)) {
    result.push({
      key: 'bankAccount',
      title: formatMessage(Messages.common_bankAccount),
      value: team.bankAccount?.number,
      width: 130,
    });

    if (team?.bankAccount?.number) {
      result.push({
        key: 'bankName',
        title: formatMessage(Messages.common_bankName),
        value: team.bankAccount?.bankName,
        width: 120,
      });
    }
  }

  result.push({
    key: 'teamAddress',
    title: formatMessage(Messages.teamPage_teamHeader_teamAddressName),
    value: getFormattedAddress(team.addresses?.postalAddress),
    width: 140,
  });

  result.push({
    key: 'email',
    title: formatMessage(Messages.common_email),
    value: team.email,
    width: 160,
  });

  if (canParentTeamBeSet(legalUnitName)) {
    result.push({
      key: 'parentTeam',
      title: formatMessage(Messages.common_parentTeam),
      value: team.parentTeamCodePrefix,
      width: 120,
    });
  }

  if (canTeamMobileNumberBeSet(legalUnitName)) {
    result.push({
      key: 'mobile',
      title: formatMessage(Messages.common_mobile),
      value: team.mobileNo,
      width: 120,
    });
  }

  result.push({
    key: 'legalNumber',
    title: formatMessage(Messages.common_legalNumber),
    value: team.legalNumber,
    width: 120,
  });

  return result;
};
